module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "apple_store.2adf5ed9.svg";